'use client';
import { useState } from 'react';
import { ELButton } from '@davincihealthcare/elty-design-system-react';

export const ColorfulHeroExpandable = ({ description, children }: { description: React.ReactNode; children?: React.ReactNode }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  if (!description) return children;
  return (
    <div className="flex w-full flex-col items-center">
      <div
        className={`mb-4 max-w-[700px] text-ellipsis text-center text-sm text-neutral-darker [&>p]:mb-2 ${!isExpanded ? 'line-clamp-2' : ''}`}
      >
        {description}
      </div>

      {children && <div className={isExpanded ? 'mb-6 flex' : 'hidden'}>{children}</div>}

      <ELButton
        label={isExpanded ? 'Mostra meno' : 'Leggi di più'}
        aria-expanded={isExpanded}
        fullRadius
        color="primary"
        variant="text"
        size="small"
        onClick={() => setIsExpanded(!isExpanded)}
      />
    </div>
  );
};
